import { Container, type ServiceIdentifier } from "inversify";
import { createContext, type FC } from "react";
import type IdentityObject from "@/src/domain/common/identity-object";
import useInject from "@/src/presentation/hooks/useInject";

export class ContainerProxy {
  private static __count = 0;

  static create(parent: ContainerProxy) {
    const child = new Container({ parent: parent.container });
    return new ContainerProxy(child, parent.level + 1);
  }

  constructor(container: Container, level: number = 0) {
    this.container = container;
    this.level = level;
    this.version = ContainerProxy.__count++;
  }

  container: Container;
  version: number;

  level: number;
}

export function injectViewmodel<T extends IdentityObject, P = { model: T }>(
  type: ServiceIdentifier<T>,
  component: FC<P>
): FC<Omit<P, "model">> {
  return (props) => {
    const model = useInject(type);
    return component({ ...props, model } as P);
  };
}

export const DIContext = createContext<ContainerProxy | null>(null);
export const DIProvider = DIContext.Provider;
